import { render, staticRenderFns } from "./extendGroup.vue?vue&type=template&id=2b912150&"
import script from "./extendGroup.vue?vue&type=script&lang=js&"
export * from "./extendGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports